import React from 'react'
import CourseForm from './CourseForm'

const AddCourse = () => {
  return (
    <>
       <CourseForm action="Add"/> 
    </>
  )
}

export default AddCourse
